import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import React from 'react';
import TemplateRows from './TemplateRows';

function GalleryItem({info, isMobile}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const props = info?.extra?.props || {};
    const rows = info?.template?.rows || [];
    const mobileColumn = info?.template?.mobile_column || [];

    const allProps = (isMobile && mobileColumn.length > 0) ? mobileColumn : rows.flatMap(row => row.columns || []).flatMap(col => col.properties || []);
    const titleProp = allProps.find(p => p.as_title === true);
    const artworkTitle = info.caption || (titleProp && props[titleProp.name]) || info.title || '';

    const content = info.body || info.extra?.body || '';

    return (
        <div className="justify" style={{ width: '100%' }}>
            <div className="justify">
                {typeof content === "string" ? parse(content) : null}
            </div>

            <TemplateRows rows={rows} mobileColumn={mobileColumn} props={props} isMobile={isMobile} titleFallback={artworkTitle} />

            <button
                className="btn-back"
                onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
            >
                Go Back
            </button>
        </div>
    );
}

export default GalleryItem;